import { streamUrl } from "../../api/media";

/**
 * Kavimo embed. `src` overrides the code for the live player's own URL.
 *
 * Only `allow` is set: it supersedes the legacy allowfullscreen attribute,
 * and specifying both makes the browser warn.
 */
const VideoFrame = ({ code, src, title, className = "h-full w-full" }) => {
  const url = src || streamUrl(code);
  if (!url) return null;

  return (
    <iframe
      title={title}
      src={url}
      className={className}
      frameBorder="0"
      scrolling="no"
      allow="fullscreen; autoplay; encrypted-media"
    />
  );
};

export default VideoFrame;
